<!-- Example split danger button -->
<div class="btn-group dropdown-container" [class.show]="shouldExpand" #wrapper>

  <!--button type=" button" class="btn btn-secondary">{{}}</button-->
  <input #inputField type="text" class="combobox-input input" [value]="selectedValue" placeholder="_ _:_ _"
    (keypress)="patternMatchInput($event, $event.target)" (blur)="onLeaveField($event, $event.target)"
    [disabled]="disabled" [required]="required" [autofocus]="autofocus">

  <button type="button" (click)="toggleDropdown()" tabindex="-1"
    class="btn btn-secondary dropdown-toggle dropdown-toggle-split combobox-button" data-toggle="dropdown"
    aria-haspopup="true" aria-expanded="false" [disabled]="disabled">
    <span class="sr-only">Toggle Dropdown</span>
  </button>


  <div class="dropdown-menu" [class.show]="shouldExpand" tabindex="-1">
    <span *ngFor="let t of items" class="dropdown-item" (mouseup)="onSelect(t.key, t.value)"
      [class.selected]="t.key === selectedKey">{{t.value}}</span>
  </div>

</div>